import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class EventHubService {
    public triggerFilterFlightsUpdate = new EventEmitter();
}
